<template>
    <div class="flip-cards">
        <div class="flip-card-frame" v-for="card in data.cards" @click="flipCard(card)">
            <div class="flip-card" :class="{'flipped': !card.attributes.flipped}">
                <div class="flip-container">
                    <div class="card-front">
                        <div class="card-text" v-if="card.content.front.attributes.type === 'text'" :style="{'font-size': card.content.front.attributes.size + 'px'}">
                            {{card.content.front.data}}
                        </div>
                        <div class="card-photo" v-if="card.content.front.attributes.type === 'photo'">
                            <img :src="card.content.front.data"/>
                        </div>
                    </div>
                    <div class="card-back">
                        <div class="card-text" v-if="card.content.back.attributes.type === 'text'" :style="{'font-size': card.content.back.attributes.size + 'px'}">
                            {{card.content.back.data}}
                        </div>
                        <div class="card-photo" v-if="card.content.back.attributes.type === 'photo'">
                            <img :src="card.content.back.data"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="is-size-7 has-text-right mr-4"><i class="fal fa-sync mr-2"></i>Click to Flip</div>
        </div>

        <div class="is-clearfix"></div>
    </div>
</template>

<script>

    export default {
        props: ['content'],
        data: function() {
            return {
                data: null
            }
        },
        methods: {
            flipCard(card) {
                card.attributes.flipped = !card.attributes.flipped;
            }
        },
        created() {
            // This is required to make the data reactive, specifically the flip flag
            this.data = this.content;
        }
    };
</script>

<style lang="scss">
    .flip-cards {
        margin: 0 1.3rem 3rem 1.3rem;

        .flip-card-frame {
            margin: 0.6rem 1rem 0 0;
            float: left;
            cursor: pointer;
        }

        .flip-card {
            border-radius: 5px;
            padding: 10px;

            width: 260px;
            height: 260px;
            overflow: hidden;

            perspective: 1000px; /* Remove this if you don't want the 3D effect */

            .flip-container {
                position: relative;
                width: 100%;
                height: 100%;
                text-align: center;
                transition: transform 0.6s;
                transform-style: preserve-3d;
                box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
                border: 1px solid #e7e7e7;
            }

            &.flipped .flip-container {
                transform: rotateY(180deg);
            }

            .card-front, .card-back {
                position: absolute;
                width: 100%;
                height: 100%;
                -webkit-backface-visibility: hidden; /* Safari */
                backface-visibility: hidden;
                display: flex;

                .card-text {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 18px;
                    width: 100%;
                    overflow: hidden;
                }
            }

            .card-front {
                background-color: white;
                color: black;
            }

            .card-back {
                background-color: white;
                transform: rotateY(180deg);
            }

            .text-photo {
                text-align: center;
            }

            .card-photo {
                img {
                    padding: 0;
                    margin: 0;
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

</style>
